import { IPlan } from "../types";

export default (descriptions: IPlan["description"]) => {
    const parsedDescriptions: IPlan["description"] = {};
    for (let [lang, description] of Object.entries(descriptions)) {
        parsedDescriptions[lang] = description.replace(/<\/?[^>]+(>|$)/g, "").replace(/\n/g, "<br/>");
    }
    return parsedDescriptions;
};
